import script from "./AddCardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCardButton.vue?vue&type=script&setup=true&lang=js"

import "./AddCardButton.vue?vue&type=style&index=0&id=7957785b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7957785b"]])

export default __exports__